import { LayoutItem } from '@horizon/dm-core';
import { MenuIcons } from '@shared/enums/MenuIcons.enum';
import { MenuRoutePaths, RoutePaths } from '@shared/enums/routes.enums';

export const layout: LayoutItem[] = [
  {
    id: 'menu-items',
    elements: [
      {
        nodeId: '01',
        nodeText: 'menu.dashboard',
        icon: MenuIcons.DASHBOARD,
        url: RoutePaths.HOME,
      },
      {
        nodeId: '02',
        nodeText: 'menu.admin',
        icon: MenuIcons.ADMIN,
        nodeChild: [
          {
            nodeId: '02-01',
            nodeText: 'menu.base_rate',
            icon: MenuIcons.BASE_RATES_CHANGES,
            url: MenuRoutePaths.BASE_RATE_CHANGES,
            breadcrumb: true,
          },
          {
            nodeId: '02-02',
            nodeText: 'menu.base_type',
            icon: MenuIcons.BASE_RATE_TYPES,
            url: MenuRoutePaths.BASE_RATE_TYPES,
            breadcrumb: true,
          },
          {
            nodeId: '02-03',
            nodeText: 'menu.transaction_codes',
            icon: MenuIcons.TRANSACTION_CODES,
            url: MenuRoutePaths.TRANSACTION_CODES,
            breadcrumb: true,
          },
          {
            nodeId: '02-04',
            nodeText: 'menu.tariff_of_charges',
            icon: MenuIcons.TARIFF_OF_CHARGES,
            url: MenuRoutePaths.TARIFF_OF_CHARGES,
            breadcrumb: true,
          },
          {
            nodeId: '02-05',
            nodeText: 'menu.brand_settings',
            icon: MenuIcons.BRAND_SETTINGS,
            url: MenuRoutePaths.BRAND_SETTINGS,
            breadcrumb: true,
          },
          {
            nodeId: '02-06',
            nodeText: 'menu.roll_loan_engine',
            icon: MenuIcons.ROLL_LOAN_ENGINE,
            url: MenuRoutePaths.ROLL_LOAN_ENGINE,
            breadcrumb: true,
          },
          {
            nodeId: '02-07',
            nodeText: 'menu.job_scheduler',
            icon: MenuIcons.JOB_SCHEDULER,
            url: MenuRoutePaths.JOB_SCHEDULER,
            breadcrumb: true,
          },
          {
            nodeId: '02-08',
            nodeText: 'menu.users',
            icon: MenuIcons.SUPER_USER_USERS,
            url: MenuRoutePaths.SUPER_USER_USERS,
            breadcrumb: true,
          },
          {
            nodeId: '02-09',
            nodeText: 'menu.roles',
            icon: MenuIcons.SUPER_USER_ROLES_AND_PERMISSIONS,
            url: MenuRoutePaths.SUPER_USER_ROLES_AND_PERMISSIONS,
            breadcrumb: true,
          },
          {
            nodeId: '02-10',
            nodeText: 'menu.scopes',
            icon: MenuIcons.SUPER_USER_SCOPES_GROUPS,
            url: MenuRoutePaths.SUPER_USER_SCOPES_GROUPS,
            breadcrumb: true,
          },
          {
            nodeId: '02-14',
            nodeText: 'menu.mandates',
            icon: MenuIcons.MANDATES,
            url: MenuRoutePaths.MANDATES,
            breadcrumb: true,
          },
          {
            nodeId: '02-11',
            nodeText: 'menu.3rd_parties',
            icon: MenuIcons.THIRD_PARTY,
            url: MenuRoutePaths.THIRD_PARTY,
            breadcrumb: true,
          },
          {
            nodeId: '02-12',
            nodeText: 'menu.business_rules',
            icon: MenuIcons.BUSINESS_RULES,
            url: MenuRoutePaths.BUSINESS_RULES,
            breadcrumb: true,
          },
          {
            nodeId: '02-13',
            nodeText: 'menu.account_transfer',
            icon: MenuIcons.ACCOUNT_TRANSFER,
            url: MenuRoutePaths.ACCOUNT_TRANSFER,
            breadcrumb: true,
          },
          {
            nodeId: '02-15',
            nodeText: 'menu.case-owner-allocation',
            icon: MenuIcons.CASE_OWNER_ALLOCATION,
            url: MenuRoutePaths.CASE_OWNER_ALLOCATION,
            breadcrumb: true,
          },
          {
            nodeId: '02-16',
            nodeText: 'menu.high-risk-jurisdiction',
            icon: MenuIcons.HIGH_RISK_JURISDICTION,
            url: MenuRoutePaths.HIGH_RISK_JURISDICTION,
            breadcrumb: true,
          },
        ],
      },
      {
        nodeId: '03',
        nodeText: 'menu.group_config',
        icon: MenuIcons.GROUP_CONFIG,
        url: MenuRoutePaths.GROUP_CONFIG,
        breadcrumb: true,
      },
      {
        nodeId: '04',
        nodeText: 'menu.transaction',
        icon: MenuIcons.TRANSACTION,
        url: MenuRoutePaths.TRANSACTION,
        breadcrumb: true,
      },
    ],
  },
  {
    id: 'recent-search',
    fields: [
      { template: 'property', name: 'pin' },
      { template: 'property', name: 'accountNumber' },
      { template: 'property', name: 'accountDescription' },
      { template: 'property', name: 'lastSearchDate' },
    ],
  },
];
